/** Formatting helpers shared by the dashboard widgets (fi-FI, VAT labels live in the widgets). */
import { format, parseISO } from 'date-fns';
import i18n from '../../../i18n';

import { formatPriceWithCurrency } from '../../../utils/vat';
import { getDateFnsLocale } from '../../../utils/languages';

export const fmtEur0 = (value) =>
  new Intl.NumberFormat('fi-FI', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(Number(value) || 0);

export const fmtEur2 = (value) => formatPriceWithCurrency(Number(value) || 0);

export const fmtNumber = (value) => new Intl.NumberFormat('fi-FI').format(Number(value) || 0);

export const fmtH = (hours) => `${(Number(hours) || 0).toFixed(1).replace('.', ',')} h`;

export const fmtPercent = (value) => `${Math.round(Number(value) || 0)} %`;

/** Decimal hour (8.5) to "08:30". */
export const hh = (decimalHour) => {
  const total = Math.round((Number(decimalHour) || 0) * 60);
  const hours = Math.floor(total / 60);
  const minutes = total % 60;
  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
};

export const dateLocale = () => getDateFnsLocale(i18n.language);

export const toDate = (value) => (value instanceof Date ? value : typeof value === 'string' ? parseISO(value) : new Date(value));

export const fmtDay = (value) => (value ? format(toDate(value), 'd.M.', { locale: dateLocale() }) : '');
export const fmtDayLong = (value) => (value ? format(toDate(value), 'EEEEEE d.M.', { locale: dateLocale() }) : '');
export const fmtTime = (value) => (value ? format(toDate(value), 'HH:mm') : '');
export const fmtDateTime = (value) => (value ? format(toDate(value), 'd.M. HH:mm', { locale: dateLocale() }) : '');

export const isoDate = (date) => format(date, 'yyyy-MM-dd');
export const todayIso = () => isoDate(new Date());
export const addDaysIso = (days) => {
  const date = new Date();
  date.setDate(date.getDate() + days);
  return isoDate(date);
};

export const ageDays = (value) => {
  if (!value) return 0;
  const then = toDate(value);
  const now = new Date();
  const start = new Date(then.getFullYear(), then.getMonth(), then.getDate());
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  return Math.max(0, Math.round((today - start) / 86400000));
};

export const daysUntil = (value) => {
  if (!value) return 0;
  const then = toDate(value);
  const now = new Date();
  const target = new Date(then.getFullYear(), then.getMonth(), then.getDate());
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  return Math.round((target - today) / 86400000);
};

export const initials = (name) =>
  String(name || '?')
    .split(/\s+/)
    .map((part) => part[0])
    .filter(Boolean)
    .slice(0, 2)
    .join('')
    .toUpperCase();

export const AVATAR_COLORS = ['#3182ce', '#805ad5', '#0d9488', '#d69e2e', '#e53e3e', '#2f8c54', '#dd6b20', '#1a365d'];
export const avatarColor = (index) => AVATAR_COLORS[Math.abs(index) % AVATAR_COLORS.length];

/** "HH:MM" (org work day setting) to a decimal hour. */
export const clockToDecimal = (clock) => {
  if (!clock) return null;
  const [hours, minutes] = String(clock).split(':').map(Number);
  return (hours || 0) + (minutes || 0) / 60;
};
